import { useEffect, useState } from "react";
export const ClientOnly = ({ children, fallback }) => {
    const [hasMounted, setHasMounted] = useState(false);
    useEffect(() => {
        setHasMounted(true);
    }, []);
    return <>{hasMounted ? children : fallback || null}</>;
};
